/**
 * Design tokens + test IDs for the first-challenge coach card + spotlight ring.
 * Matches ChallengeTour.dc.html (variant 1a): dark card, purple accent, glowing ring.
 */

export const COACH_C = {
  card: '#161020',
  cardBorder: 'rgba(167,139,250,0.32)',
  accent: '#A78BFA',
  accentInk: '#111827',
  ink: '#F7FAFC',
  body: '#D1D5DB',
  muted: '#6B7280',
  avatarBg: '#2F1B6E',
  ringPurple: '#A78BFA',
} as const;

/** Coach card width (design: 312px), and spotlight padding baked around the target rect. */
export const COACH_CARD_WIDTH = 312;
export const COACH_ARROW_SIZE = 16;

export const COACH_TEST_IDS = {
  CARD: 'fc-coach-card',
  SKIP: 'fc-coach-skip',
  GOTIT: 'fc-coach-gotit',
  HINT: 'fc-coach-hint',
  RING: 'fc-spotlight-ring',
  RESUME: 'fc-coach-resume',
} as const;

export const COACH_COPY = {
  skip: 'Skip tour',
  gotIt: 'Got it ›',
  tapHint: 'Tap the highlight',
  resume: '▶ Resume tour',
} as const;
